import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";

type ReviewerEditLockAdornmentProps = {
  title?: string;
};

export function ReviewerEditLockAdornment(props: Readonly<ReviewerEditLockAdornmentProps>) {
  const { title } = props;
  if (!title) return null;

  return (
    <InputAdornment position="start">
      <ReviewerEditLockIcon title={title} />
    </InputAdornment>
  );
}

export function ReviewerEditLockIcon(props: Readonly<ReviewerEditLockAdornmentProps>) {
  const { title } = props;
  if (!title) return null;

  return (
    <Tooltip enterDelay={600} placement="top-start" title={title}>
      <Box
        aria-label="Why this field is locked"
        component="span"
        onClick={(event) => event.stopPropagation()}
        onMouseDown={(event) => event.stopPropagation()}
        role="img"
        sx={{
          alignItems: "center",
          color: "warning.main",
          display: "inline-flex",
          pointerEvents: "auto",
        }}
      >
        <LockOutlinedIcon fontSize="small" />
      </Box>
    </Tooltip>
  );
}

// The roster's lock used to be an Avatar that replaced the member's own. It is a column of its own
// now (#4955): the avatar carries the five-state redline colour ladder, and swapping it out took the
// reviewer's primary signal away on exactly the rows they had opened the locked roster to read.
